export const environment = {
    production: false,
    API_BASE_URL: 'https://backend.urbanize-test.com/v1', // http://localhost:8080/v1
    URBAN_PAZ_EXCEL_SERVER_URL: 'https://paz-server.urbanize-test.com/api',
    AUTH_BASE_URL: 'https://auth.urbanize-test.com',
    WS_URL: 'wss://ws.urbanize.ai',
    BUILDING_PIPELINE_API: 'https://building-pipe.urbanize-test.com/api/',
    URBAN_UTILS_URL: 'https://utils.urbanize-test.com/api',
    GOVMAP_TOKEN: '9b155647-d677-4e09-95cc-f38221643ff4'
};